import React from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import { cx } from '../components/ui';
import { useTheme } from './ThemeContext';

const OPTIONS = [['system', 'Match device', Monitor], ['light', 'Light', Sun], ['dark', 'Dark', Moon]];

// Three-way appearance control. `onDark` styles it for dark surfaces such as the footer.
export default function AppearanceSwitch({ onDark = false, className }) {
  const { preference, setPreference } = useTheme();
  return (
    <div role="radiogroup" aria-label="Appearance"
      className={cx('inline-flex rounded-pill p-1 ring-1 ring-inset', onDark ? 'bg-white/5 ring-white/15' : 'bg-paper-sunk ring-line', className)}>
      {OPTIONS.map(([value, label, Icon]) => {
        const on = preference === value;
        return (
          <button key={value} type="button" role="radio" aria-checked={on} title={label} aria-label={label} onClick={() => setPreference(value)}
            className={cx('flex h-8 w-8 items-center justify-center rounded-pill transition',
              on ? (onDark ? 'bg-white/15 text-white' : 'bg-surface text-ink shadow-sm') : (onDark ? 'text-white/50 hover:text-white' : 'text-ink-muted hover:text-ink'))}>
            <Icon className="h-4 w-4" />
          </button>
        );
      })}
    </div>
  );
}
